module.exports = __webpack_public_path__ + "img/1544881311.96055d21.jpg";